import React, { useState } from "react";
import { FaShoppingCart } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import CartDropdown from "../components/CartDropdown";
import AccountDropdown from "../components/AccountDropdown";
import "../styles/HomeNavbar.css";

const HomeNavbar = ({
  cart,
  setCart,
  user,
  isLoggedIn,
  onLoginSuccess,
  onRemoveItem,
  guestCartId,
  setSelectedCategories, // Ensure this prop is passed from the parent
  onUpdateQuantity, // Ensure this prop is passed from the parent
  resetSelectedCategory,
}) => {
  const [isCartDropdownOpen, setIsCartDropdownOpen] = useState(false);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Toggle cart dropdown
  const toggleCartDropdown = () => {
    setIsCartDropdownOpen((prev) => !prev);
    setIsAccountDropdownOpen(false); // Close account dropdown when opening cart dropdown
  };

  // Toggle account dropdown
  const toggleAccountDropdown = () => {
    setIsAccountDropdownOpen((prev) => !prev);
    setIsCartDropdownOpen(false); // Close cart dropdown when opening account dropdown
  };

// Handle logout
// Handle logout properly with API call
const handleLogout = async () => {
  try {
    await fetch(`${API_BASE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });

    // Clear local storage data
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("guestCartId");

    onLoginSuccess(null);
    setIsAccountDropdownOpen(false);

    window.location.href = `/home?logout=${Date.now()}`;
  } catch (error) {
    console.error("Logout error:", error);
    window.location.href = "/home";
  }
};


  // Handle logo click
  const handleLogoClick = (e) => {
    e.preventDefault();
    setSelectedCategories([]); // Clear selected categories
    navigate("/home"); // Navigate to the homepage
  };

  return (
    <nav className="home-navbar">
      <div className="navbar-bottom-border"></div>
      <div className="logo">
        <a href="/home" onClick={resetSelectedCategory}>
          <img src="/logo-net.png" alt="Website Logo" className="logo-image" />
        </a>
      </div>

      <ul className="nav-links">
        <li>
          <a href="https://myzmaj.com/" className="plain-link">
            Video nadzor
          </a>
        </li>
        <li>
          <a href="https://myzmaj.rs/" className="plain-link">
            Internet
          </a>
        </li>
        <li className="cart-icon">
          <div className="cart-icon-wrapper" onClick={toggleCartDropdown}>
            <FaShoppingCart size={24} />
            {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
          </div>
          {isCartDropdownOpen && (
            <div className="cart-dropdown-container">
              <CartDropdown
                cartItems={cart}
                onRemoveItem={onRemoveItem}
                onUpdateQuantity={onUpdateQuantity} // Pass onUpdateQuantity
                isLoggedIn={isLoggedIn}
                user={user}
              />
            </div>
          )}
        </li>

        <li className="account-section">
          {isLoggedIn ? (
            <>
              <button className="account-icon-button" onClick={toggleAccountDropdown}>
                <svg
                  className="account-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </button>
              <div className="account-dropdown-container">
                {isAccountDropdownOpen && (
                  <AccountDropdown handleLogout={handleLogout} user={user} />
                )}
              </div>
            </>
          ) : (
            <div className="auth-links">
              <Link to="/login">Uloguj se</Link>
              <Link to="/register">Registruj se</Link>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default HomeNavbar;